<template>
  <section id="map" itemscope class="radius-big bg-black t-white">

    <div class="gap-zero pos-relative cols-2">
    	<!-- Right col -->
      <aside  style="display: grid; grid-template-rows: 1fr 0.5fr" class="w-100 h-100 gap-small  pd-thin">
      
        <div style="min-height: 20rem" class="h-100 pos-relative">
            <img class="object-fit-cover radius-big o-hidden pos-absolute h-100 w-100" src="/pictures/photo_3.jpg" itemprop="contentUrl" :alt="t('map.first_image_alt')">
        </div>

        <div style="min-height: 20rem" class="h-100 w-100 pos-relative gap-small cols-2">
          <div class="pos-relative">
            <img class="object-fit-cover radius-big o-hidden  pos-absolute h-100 w-100" src="/pictures/photo_15.jpg" itemprop="contentUrl" :alt="t('map.first_image_alt')">
          </div>
          <div class="pos-relative">
              <img class="object-fit-cover radius-big o-hidden pos-absolute h-100 w-100" src="/pictures/photo_18.jpg" itemprop="contentUrl" :alt="t('map.first_image_alt')">
          </div>
        </div>
       
     	</aside>
			
      <!-- Left col -->
      <article class="pd-big flex-column flex-nowrap flex col-2 col" itemprop="description">
				<h3 class="mn-b-medium" itemprop="name">
					<span class="text-fade-in">
						<span class="text-splitted">{{t('map.title')}}</span>
					</span>
				</h3> 

        <p class="p-big mn-b-small t-transp"><span itemprop="address">{{t('map.description')}}</span></p>

        <div class="pd-big br-1px br-solid br-white-transp radius-big">
          <p class="p-big mn-b-small" itemprop="name">{{ t('contacts.name') }}</p>
          
          <address class="d-block mn-b-small" itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
            <a :href="t('contacts.addressLink')" target="_blank" rel="noopener"> 
              <span itemprop="streetAddress">{{ t('contacts.streetAddress') }}</span>, 
              <span itemprop="addressLocality">{{ t('contacts.addressLocality') }}</span>, 
              <span itemprop="addressRegion">{{ t('contacts.addressRegion') }}</span>, 
              <span itemprop="postalCode">{{ t('contacts.postalCode') }}</span>
            </a>
          </address>
          
          <span class="d-block mn-b-small" itemprop="telephone">
            <a :href="'tel:' + t('contacts.telephone')" class="t-white">{{ t('contacts.telephone') }}</a>
          </span>

          <span class="d-block mn-b-medium" itemprop="email">
            <a :href="'mailto:' + t('contacts.email')" class="t-white">{{ t('contacts.email') }}</a>
          </span>

          <a :href="t('contacts.addressLink')" target="_blank" rel="noopener" class="button hover-scale-1 t-white bg-main">
            {{ t('contacts.seeOnGoogle') }}
          </a>
        </div>
      </article>
    </div>
  </section>
</template>

<script setup>
	import { useI18n } from 'vue-i18n'
	
	const { t } = useI18n({ 
    messages: {
      "en": {
        "map": {
          "title": "Nestled in the heart of Karon, The Commune offers breathtaking views of the Andaman Sea.",
          "description": "Just steps away from The Commune, our guests can soak up the sun, surf the waves, or explore the surrounding shops and restaurants. Our bar and terrace boast breathtaking views of the Andaman Sea, making it the perfect spot to unwind and relax with a drink in hand. For more information and directions, check out our location on Google Maps below.",
          "alt1": "The Commune",
          "alt2": "The Commune Gallery",
          "alt3": "The Commune Gallery",
          "link": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3952.6334858661976!2d98.29080421493127!3d7.828559808787166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30502551b4a019f1%3A0x989bc4c4c59a1c63!2sTHE%20COMMUNE%20%7C%20Terrace%20%26%20Bar!5e0!3m2!1sen!2sth!4v1675674545782!5m2!1sen!2sth"
        }
      },
      "ru": {
        "map": {
          "title": "Укрывшись в сердце Карона, The Commune предлагает потрясающие виды на Андаманское море.",
          "description": "Всего в нескольких шагах от The Commune, наши гости могут позагорать на солнце, покататься на волнах или исследовать окружающие магазины и рестораны. Наш бар и терраса предлагают захватывающие виды на Андаманское море, что делает их идеальным местом для отдыха с бокалом в руке. Для получения дополнительной информации и указаний, посмотрите наше местоположение на Google Maps ниже.",
          "alt1": "The Commune",
          "alt2": "Галерея The Commune",
          "alt3": "Галерея The Commune",
          "link": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3952.6334858661976!2d98.29080421493127!3d7.828559808787166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30502551b4a019f1%3A0x989bc4c4c59a1c63!2sTHE%20COMMUNE%20%7C%20Terrace%20%26%20Bar!5e0!3m2!1sru!2sth!4v1675674545782!5m2!1sru!2sth"
        }
      },
      "fr": {
        "map": {
          "title": "Niché au cœur de Karon, The Commune offre des vues à couper le souffle sur la mer d'Andaman.",
          "description": "À quelques pas de The Commune, nos invités peuvent profiter du soleil, surfer sur les vagues ou explorer les boutiques et restaurants environnants. Notre bar et terrasse offrent des vues imprenables sur la mer d'Andaman, ce qui en fait l'endroit idéal pour se détendre avec un verre à la main. Pour plus d'informations et d'instructions, consultez notre emplacement sur Google Maps ci-dessous.",
          "alt1": "The Commune",
          "alt2": "Galerie The Commune",
          "alt3": "Galerie The Commune",
          "link": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3952.6334858661976!2d98.29080421493127!3d7.828559808787166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30502551b4a019f1%3A0x989bc4c4c59a1c63!2sTHE%20COMMUNE%20%7C%20Terrace%20%26%20Bar!5e0!3m2!1sfr!2sth!4v1675674545782!5m2!1sfr!2sth"
        }
      },
      "de": {
        "map": {
          "title": "Im Herzen von Karon gelegen, bietet The Commune atemberaubende Aussichten auf das Andamanensee.",
          "description": "Nur wenige Schritte von The Commune entfernt können unsere Gäste die Sonne genießen, die Wellen surfen oder die umliegenden Geschäfte und Restaurants erkunden. Unsere Bar und Terrasse bieten atemberaubende Ausblicke auf das Andamanensee, was sie zum perfekten Ort macht, um sich mit einem Getränk in der Hand zu entspannen. Für weitere Informationen und Anweisungen, sehen Sie sich unseren Standort auf Google Maps unten an.",
          "alt1": "The Commune",
          "alt2": "Galerie The Commune",
          "alt3": "Galerie The Commune",
          "link": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3952.6334858661976!2d98.29080421493127!3d7.828559808787166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30502551b4a019f1%3A0x989bc4c4c59a1c63!2sTHE%20COMMUNE%20%7C%20Terrace%20%26%20Bar!5e0!3m2!1sde!2sth!4v1675674545782!5m2!1sde!2sth"
        }
      },
      "it": {
        "map": {
          "title": "Nascosto nel cuore di Karon, The Commune offre viste mozzafiato sul Mare delle Andamane.",
          "description": "A pochi passi da The Commune, i nostri ospiti possono prendere il sole, cavalcare le onde o esplorare i negozi e i ristoranti circostanti. Il nostro bar e terrazza offrono viste mozzafiato sul Mare delle Andamane, rendendolo il luogo perfetto per rilassarsi con un drink in mano. Per ulteriori informazioni e indicazioni, controlla la nostra posizione su Google Maps qui sotto.",
          "alt1": "The Commune",
          "alt2": "Galleria The Commune",
          "alt3": "Galleria The Commune",
          "link": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3952.6334858661976!2d98.29080421493127!3d7.828559808787166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30502551b4a019f1%3A0x989bc4c4c59a1c63!2sTHE%20COMMUNE%20%7C%20Terrace%20%26%20Bar!5e0!3m2!1sit!2sth!4v1675674545782!5m2!1sit!2sth"
        }
      },
      "zh": {
        "map": {
          "title": "位于Karon的中心，The Commune提供令人惊叹的安达曼海景色。",
          "description": "从The Commune走出去，我们的客人可以晒太阳，冲浪，或者探索周围的商店和餐厅。我们的酒吧和露台提供令人惊叹的安达曼海景观，使其成为放松并手持饮料的理想之地。有关更多信息和指示，请查看下面的Google地图位置。",
          "alt1": "The Commune",
          "alt2": "The Commune画廊",
          "alt3": "The Commune画廊",
          "link": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3952.6334858661976!2d98.29080421493127!3d7.828559808787166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30502551b4a019f1%3A0x989bc4c4c59a1c63!2sTHE%20COMMUNE%20%7C%20Terrace%20%26%20Bar!5e0!3m2!1szh!2sth!4v1675674545782!5m2!1szh!2sth"
        }
      }
    }
  })
</script>

<style lang="scss">
	.map-iframe  {
		min-height: 30rem;
		max-height: 30rem;
	}

	@media screen and (max-width: 1280px) {
		#map {
			.first-image  {
				margin-bottom: 1rem !important;
			}
			.col-2  {
		    .col:first-of-type {
		     	order: 2
		    }

		    .col:last-of-type {
		      order: 1;
		      min-height: 33vh;
		      padding-bottom: 0;
		    }
		  }
		}
	}

</style>